// Fail closed for missing build configuration and non-production hosts.
// Keep a runtime hostname check even when production static files are copied to UAT.
export const isGoogleTrackingAllowed = () =>
  typeof window !== 'undefined' &&
  process.env.ENV === 'prod' &&
  window.location.hostname === 'www.bestdeals.co.nz';
